let accordionHeaders = document.querySelectorAll('.nh-accordion-section h2');

  [].forEach.call(accordionHeaders, function( acc ) {

    acc.addEventListener('click', (e) => {

      e.preventDefault();
      let group = acc.parentNode.parentNode.querySelector(".nh-accordion");
      let content = group?.querySelector(".inner");
      let height = content.offsetHeight;

      let current = document.querySelector(".nh-accordion.current");

      if (current != null && current !== group) {
        current.classList.remove("current");
        current.parentNode.querySelector(".nh-accordion-title").classList.remove("open");
        current.style.height = 0 + "px";
      }

      let currentHeight = group.offsetHeight;

      if (currentHeight == 0) {
        group.style.height = height + "px";
        group.classList.add("current");
        acc.parentNode.classList.add("open");
      } else {
        group.style.height = 0 + "px";
        group.classList.remove("current");
        acc.parentNode.classList.remove("open");
      }

    });
  });



let faqButtons = document.querySelectorAll('.nh-faq-navigation button');

let currentHash = window.location.hash.toLowerCase();
currentHash = currentHash.replace('#', '');
let validhashes = ['orders', 'shipping', 'about'];
if ( validhashes.includes(currentHash) == false ){
  currentHash = 'orders';
}

console.log('currentHash is '+currentHash);

[].forEach.call(faqButtons, function( btn ) {

  if ( btn.getAttribute('data-section') == currentHash ){
    btn.parentNode.classList.add('current');
  } else {
    btn.parentNode.classList.remove('current');
  }
});

currentHash = currentHash.replace('#', '');

let firstFaq = document.querySelector('.'+currentHash);
firstFaq.style.opacity = 0;
firstFaq.style.transform = 'translate3d(0,20px,0)';
firstFaq.classList.remove('hidden');
setTimeout( () => {
    firstFaq.style.opacity = '1';
    firstFaq.style.transform = 'translate3d(0,0,0)';
}, 50 );



[].forEach.call(faqButtons, function( btn ) {

  btn.addEventListener('click', () => {
    let current = document.querySelector('.nh-faq-navigation li.current');
    current.classList.remove('current');
    btn.parentNode.classList.add('current');

    let visibleFaq = document.querySelector('.nh-accordion-holder:not(.hidden)');
    visibleFaq.style.opacity = '0';

    let currentClass = btn.getAttribute('data-section');
    window.location.hash = '#'+currentClass;

    setTimeout( () => {
      visibleFaq.classList.add('hidden');

      let newFaq = document.querySelector('.'+currentClass);
      newFaq.style.transform = 'translate3d(0,20px,0)';
      newFaq.style.opacity = 0;
      newFaq.classList.remove('hidden');
    }, 350 );

    setTimeout( () => {
      let currentClass = btn.getAttribute('data-section');
      let newFaq = document.querySelector('.'+currentClass);
      newFaq.style.transform = 'translate3d(0,0px,0)';
      newFaq.style.opacity = '1';
    }, 400 )

  });
});
